import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';

import { Account } from '@libs/src/models/account.model';
import { IAppState } from '@main-client/src/app/app.state';
import { USER_ONBOARDING_ROUTE_PATHS } from '@main-client/src/app/user-onboarding/user-onboarding.helper';
import { filterVisibleGroups } from '@main-client/src/app/user/user.helpers';

import get from 'lodash-es/get';
import isEmpty from 'lodash-es/isEmpty';

@Injectable()
export class UserOnboardingLegacyGuardService implements CanActivate {
  constructor(
    public router: Router,
    public store: Store<IAppState>,
  ) {}

  canActivate() {
    return this.store.select('user').pipe(
      filter((user: Account) => !isEmpty(user)),
      take(1),
      map((user: Account) => {
        const userGroups = filterVisibleGroups(user.groups);
        if (!isEmpty(userGroups)) {
          return this.router.createUrlTree(
            ['/get-started', USER_ONBOARDING_ROUTE_PATHS.hubSegments],
            {
              queryParams: {
                selectedGroupId: get(userGroups[0], 'document._id'),
              },
            },
          );
        }
        return this.router.createUrlTree([
          '/get-started',
          USER_ONBOARDING_ROUTE_PATHS.hubs,
        ]);
      }),
    );
  }
}
